import styles from "./index.module.css";

function Container({ children, maxWidth }) {

    return (
      <div className={styles.view} style={{ maxWidth: maxWidth || "" }}>
        {children}
      </div>
    )
}
  
export default Container

export const Column = ({ width, alignItems, justifyContent, gap, padding, margin, style, children }) => {

    return (
        <div style={{ 
            width: width ? width : "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: alignItems ? alignItems : "",
            justifyContent: justifyContent ? justifyContent : "",
            gap: gap ? gap : 10,
            padding: padding ? padding : 0,
            margin: margin ? margin : 0,
            ...style,
         }}>
            {children}
        </div>
    );
}

export const Row = ({ width, alignItems, justifyContent, gap, padding, margin, flexWrap, style, children }) => {

    return (
        <div style={{ 
            width: width ? width : "100%",
            display: "flex",
            flexWrap: flexWrap ? flexWrap : "",
            flexDirection: "row",
            alignItems: alignItems ? alignItems : "",
            justifyContent: justifyContent ? justifyContent : "",
            gap: gap ? gap : 10,
            padding: padding ? padding : 0,
            margin: margin ? margin : 0,
            ...style,
         }}>
            {children}
        </div>
    );
}